import type { PartialSearchParams } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export const autoCompleteIsAnytime = (searchParams: PartialSearchParams): PartialSearchParams => {
  const firstLeg = searchParams && searchParams.legs && searchParams.legs[0];
  // Detect if there is some changes on date and autocomplete for is_anytime, otherwise ignore it and return the origin searchParams
  if (firstLeg?.date !== undefined) {
    const { is_anytime, ...restOfLeg } = firstLeg;
    return { ...searchParams, legs: [{ ...restOfLeg, is_anytime: false }] };
  }
  return searchParams;
};
